import React, { useContext } from "react";
import Card from "../component/shared/Card";
import { getRandomColor, getContrastingTextColor } from "../utils/getRandomColor";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/Auth";
import { IoMdLogOut } from "react-icons/io";
import { MdOutlineSettings } from "react-icons/md";
import { FaHome } from "react-icons/fa";
import axiosInstance from "../utils/Axios";
import { toast } from "react-toastify";
import NotFound from "./NotFound";



const Dashboard = ({ title, cardItem }) => {
  const [loading, setLoading] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    setTitle,
    setIsAuthenticated,
    accessOfModules,
    userRole,
    ChildCardModules,
    setChildCardsModules,
  } = useContext(AuthContext);

  const pathHandler = async (path, reportId, cardTitle, groupId, url, group_of) => {
    setTitle(cardTitle);
    if (!path && reportId) {
      if (groupId === reportId) {
        const embedUrl = url.replace("https://lookerstudio.google.com/embed/", "");
        navigate(`/dashboard?url=${encodeURIComponent(embedUrl)}`);
        return;
      }
      if (groupId) {
        navigate(`/${cardTitle.split(" ").join("-")}/group_id/${groupId}/report/${reportId}/group_of/${group_of}`);
        ///${group_of}
        return;
      } else {
        navigate(`/${cardTitle.split(" ").join("-")}/report/${reportId}`);
        return;
      }
    } else if (path) {
      // if (groupId === reportId) {
      //   navigate('/not-found')
      //   return;
      // }
      try {
        const response = await axiosInstance.get(`/pbi-dashbord/getSingleModuleInfo?moduleName=${encodeURIComponent(cardTitle)}`);
        setChildCardsModules(response?.data);
        console.log(response?.data);
        navigate(`/parent`);
      } catch (error) {
        console.log("Error while loading child module info.", error);
        toast.error("Error while loading child module.");
      }
    }
  };


  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("email");
    localStorage.removeItem("timeLeft");
    localStorage.removeItem("User_info");
    navigate("/login");
  };

  // Filter card items based on accessOfModules
  const filteredCardItems = cardItem.filter(item => {
    if (accessOfModules.includes("*") || accessOfModules.includes("admin")) {
      return true;
    }
    return accessOfModules.includes(item.title.toLowerCase());
  });

  const isActive = (path) => location.pathname === path;

  return (
    <div className="w-full pb-16 md:mb-0 relative min-h-screen bg-green-50">
      {/* Header Section */}
      <header className="flex justify-between items-center px-8 sticky top-0 w-full bg-white shadow-md z-10 p-4">
        <div className="flex items-center justify-center space-x-4">
          <img
            src="/Katyayanic-organics.png"
            alt="Katyayanic Organics"
            className="w-40"
          />
          <h1 className="text-2xl md:text-4xl coda-regular font-extrabold uppercase text-green-800 tracking-wide">
            {title}
          </h1>
        </div>
        <div className="hidden md:flex items-center justify-center space-x-12">
          <button onClick={() => navigate('/')}>
            <FaHome size={40} className="hidden md:block bottom-6 left-6 border border-green-100 text-gray-900 bg-green-50 p-2 rounded-full text-5xl cursor-pointer" />
            <p className="text-xs">Home</p>
          </button>
          {userRole === "admin" && (
            <button onClick={() => navigate('/department/user-management/user-info')}>
              <MdOutlineSettings size={40} className=" hidden md:block bottom-6 left-24 border border-green-100 text-gray-900 bg-green-50 p-2 rounded-full text-5xl cursor-pointer" />
              <p className="text-xs">Setting</p>
            </button>
          )}
          <button onClick={logout}>
            <IoMdLogOut size={40} className="hidden text-red-500 md:block bottom-6 right-6 border border-green-100 bg-green-50 p-2 rounded-full text-5xl cursor-pointer" />
            <p className="text-xs">Logout</p>
          </button>
        </div>
      </header>

      {/* Main Section */}
      <main className="p-4 sm:p-8">
        {filteredCardItems.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8 lg:gap-12">
            {filteredCardItems.map((item, index) => {
              const backgroundColor = getRandomColor();
              const textColor = getContrastingTextColor(backgroundColor);

              return (
                <div
                  key={index}
                  onClick={() => pathHandler(item.path, item.reportId, item.title, item.groupId, item.url_looker, item.group_of)}
                  className="cursor-pointer transition-transform transform hover:scale-105 hover:shadow-lg duration-300 ease-in-out"
                >
                  <Card
                    cardStatus={item.cardStatus || ""}
                    title={item.title}
                    content={`Explore more about ${item.title}.`}
                    backgroundColor={backgroundColor}
                    textColor={textColor}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-96">
            <p className="text-lg text-red-600 font-semibold">
              You have no access to any modules. Connect to admin for assistance.
              <NotFound />
            </p>
          </div>
        )}
      </main>

      {/* Logout Button */}
    </div>
  );
};

export default Dashboard;
